import { useCallback } from "react";
import { useFolderTree } from "../../contexts/folderTree.js";
function useCreatableDraftPatch() {
    const { creatableDraft, set } = useFolderTree();
    return useCallback((patch)=>{
        if (!creatableDraft) {
            return;
        }
        const next = {
            ...creatableDraft
        };
        patch(next);
        set({
            creatableDraft: next
        });
    }, [
        creatableDraft,
        set
    ]);
}
export { useCreatableDraftPatch };
